import template from './map-hover-popup.html';

class MapHoverPopupController {
  constructor() {}

  $onInit() {}

  $onDestroy() {
    this.asset = undefined;
  }
}

export default {
  template,
  controllerAs: 'hpVm',
  controller: MapHoverPopupController,
  bindings: {
    asset: '<'
  }
};
